<div class="estimate-setting-container">
    <div class="row pb-3">
        <label class="estimate-setting-label">{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_TITLE' | translate}}</label>
    </div>
    <div class="estimate-setting-content" [formGroup]="estimateSettingsForm">
        <!-- Estimate Name -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ESTIMATE_NAME' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <mat-form-field class="full-width col-sm-12" appearance="outline">
                    <input matInput formControlName="estimateName" maxLength="30">
                </mat-form-field>
            </div>

        </div>
        <!-- Estimate Description -->
        <div class="row row-height-textarea align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ESTIMATE_DESCRIPTION' |
                    translate}}</label></div>
            <div class="col-sm-4">
                <mat-form-field class="full-width col-sm-12" appearance="outline">
                    <textarea matInput formControlName="estimateDescription" rows="3" maxLength="256"></textarea>
                </mat-form-field>
            </div>
        </div>
        <!-- Estimate Number -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ESTIMATE_NUMBER'| translate}}</label>
            </div>
            <div class="col-sm-4">
                {{ estimateNumber.value }}
            </div>
        </div>
        <!-- Estimate Type -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"> <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ESTIMATE_TYPE' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="estimateType">
                        @for(type of estimateTypes; track type.id) {
                        <mat-option [value]="type.id" [hidden]="type.id==2 && isCreateNewEstimate">
                            {{type.description}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <!-- Vertical market -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_VERTICAL_MARKET' |
                    translate}}</label></div>
            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select class="full-width" appearance="outline" formControlName="verticalMarket" >
                        @for(market of verticalMarkets; track market.id) {
                        <mat-option [value]="market.id">
                            {{market.description}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <!-- Business -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_BUSINESS' | translate}}</label></div>
            <div class="col-sm-4">
                {{ business.value }}
            </div>
        </div>
        <!-- Segment -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_SEGMENT' | translate}}</label></div>
            <div class="col-sm-4">
                {{ segment.value }}
            </div>
        </div>

        <!-- Sales Type -->
        @if (isSalesTypeVisible) {
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'SALES_TYPE' | translate}}</label></div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="salesType" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="51">{{'NEW' | translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="52">{{'OTHER' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }

        <!-- System Type -->
        @if (isGmPercentVisible) {
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'SYSTEM_TYPE' | translate}}</label></div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="systemType" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="1">{{'SIEMENS' |
                        translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="2">{{'THIRD_PARTY' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }

        <!-- GM% -->
        @if (isGmPercentRateVisible) {
        <div class="row row-height align-items-center">
            <div class="col-sm-3"><label>{{'GM%' | translate}}</label></div>
            <div class="col-sm-2">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <input matInput [appNumericMask]="gmPercentConfig" formControlName="gmPercent" class="text-end">
                </mat-form-field>
            </div>
            <div class="col-sm-3">{{ minimumGmPercent | decimalPrecision }}% {{'MINIMUM_GM_%' | translate}}</div>
        </div>
        }

        <!-- Job Duration -->
        <fieldset>
            <legend>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_JOB_DURATION' | translate}}</legend>

            <div class="row row-height p-20 align-items-center">
                <div class="col-sm-3">
                    <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_JOB_START_DATE' | translate}}</label>
                </div>
                <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="full-width col-sm-12">
                        <input matInput [matDatepicker]="jobStartDate" formControlName="jobStartDate"
                            (dateChange)="onJobStartDateChange()">
                        <mat-datepicker-toggle matSuffix [for]="jobStartDate"></mat-datepicker-toggle>
                        <mat-datepicker #jobStartDate></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-3 d-flex align-items-center justify-content-center gap-2">
                    <mat-form-field appearance="outline" class="full-width col-sm-5">
                        <input matInput type="number" min="0" formControlName="durationDays"
                            (blur)="onDurationDaysBlur()">
                    </mat-form-field>
                    <label class="mb-2">{{'COST_REVIEW_DURATION_DAYS' | translate}}</label>
                </div>
            </div>
            <div class="row row-height align-items-center p-20">
                <div class="col-sm-3">
                    <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_JOB_END_DATE' | translate}}</label>
                </div>
                <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="full-width col-sm-12">
                        <input matInput [matDatepicker]="jobEndDate" formControlName="jobEndDate"
                            (dateChange)="onJobEndDateChange()">
                        <mat-datepicker-toggle matSuffix [for]="jobEndDate"></mat-datepicker-toggle>
                        <mat-datepicker #jobEndDate></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </fieldset>
        <!-- CMMC -->
        @if (showCmmcAndVerticalSalesSection) {
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'CUI_LEVEL' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="cmmc" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="false">{{'LEVEL_1_FCI' |
                        translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="true">{{'LEVEL_2_CUI' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!-- TODO: value to be updated in respective model on OK button click & saved to DB on estimate save operation. -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'VERTICAL_SALES_TEAM' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="ecs" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="true">{{'YES' |
                        translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="false">{{'NO' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        }

        <!-- User type -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_USER_TYPE' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <mat-select formControlName="userType">
                        @for(userType of userTypes; track userType.id) {
                        <mat-option [value]="userType.id">
                            {{userType.description}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <!-- Submittal Packages -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_SUBMITTAL_PACKAGES' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <app-multi-pdf-report-dropdown class="col-sm-12" [reportsList]="submittalPackageData"
                    [control]="estimateSettingsForm.controls.submittalPackage">
                </app-multi-pdf-report-dropdown>
            </div>
        </div>

        <!-- Mechanical Fee -->
        @if (showMechanicalFeeSection) {
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'MECHANICAL_FEE' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="mechanicalFee" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="true"
                        disabled>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ENABLED' | translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="false"
                        disabled>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_DISABLED' | translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-sm-4">
                <mat-checkbox formControlName="includeMechanicalFeeInPpm" color="primary">
                    {{'INCLUDE_IN_PPM' | translate}}
                </mat-checkbox>
            </div>
        </div>
        }

        <!-- Productivity Reserve -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'PRODUCTIVITY_RESERVE' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="productivityReserve" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="true" disabled>
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ENABLED' | translate}}
                    </mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="false" disabled>
                        {{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_DISABLED' | translate}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-sm-4">
                <mat-checkbox formControlName="includeProductivityReserveInPpm" color="primary">
                    {{'INCLUDE_IN_PPM' | translate}}
                </mat-checkbox>
            </div>
        </div>
        <!-- Risk -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_RISK' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="risk" class="estimate-setting-radio-group"
                    (change)="onRiskSelectionChange()">
                    <mat-radio-button color="primary" class="w-50"
                        [value]="true">{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_AUTO' | translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50"
                        [value]="false">{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_PROJECT_ENTRY' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-sm-4">
                <mat-checkbox formControlName="includeRiskInPpm" color="primary">
                    {{'INCLUDE_IN_PPM' | translate}}
                </mat-checkbox>
            </div>
        </div>
        @if (showSubcontractorFeeSection) {
        <!-- Sub contractor Fee -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'SUB_CONTRACTOR_FEE' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="subContractorFee" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50" [value]="true"
                        disabled>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ENABLED' | translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50" [value]="false"
                        disabled>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_DISABLED' | translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-sm-4">
                <mat-checkbox formControlName="includeSubContractorFeeInPpm" color="primary">
                    {{'INCLUDE_IN_PPM' | translate}}
                </mat-checkbox>
            </div>
        </div>
        }
        <!-- Technology Fee -->
        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_TECHNOLOGY_FEE' | translate}}</label>
            </div>
            <div class="col-sm-5">
                <mat-radio-group formControlName="technologyFee" class="estimate-setting-radio-group">
                    <mat-radio-button color="primary" class="w-50"
                        [value]="true">{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_ENABLED' |
                        translate}}</mat-radio-button>
                    <mat-radio-button color="primary" class="w-50"
                        [value]="false">{{'MENU_FILE_PROPERTIES_ESTIMATE_SETTINGS_DISABLED' |
                        translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-sm-4">
                <mat-checkbox formControlName="includeTechnologyFeeInPpm" color="primary">
                    {{'INCLUDE_IN_PPM' | translate}}
                </mat-checkbox>
            </div>
        </div>


    </div>
</div>